// extracted by mini-css-extract-plugin
export default {"span":"check-box-module__span___gn3iF checked-input-module__span___DsbCM common-module__errorStateBorder___dqUz3","checkmark":"check-box-module__checkmark____uCWR"};